<template>
    <div class="demo-3">
        <Header></Header>
        <main>
            <div class="container">
                <div data-scroll>
                    <div class="content content--alternate content--padded">
                        <div class="content__item content__item--expand" :style="`--aspect-ratio: ${month.aspectratio};`" v-for="(month, index) in this.data" :key="'A' + index">
                            <div class="content__item-imgwrap" :style="`--padding-bottom: ${month.paddingBottom};`">
                                <!-- <div class="content__item-img" :style="{ backgroundImage: `url(${require(`@/assets/images/year_in_review/${month.image}`)})` }"></div> -->
                                <div class="content__item-img">
                                    <div class="content__item--imgwrapper">
                                        <div class="content__item--image">
                                            <img class="img-fluid" :src="`${require(`@/assets/images/year_in_review/${month.image}`)}`">
                                        </div>
                                        <h2 class="content__item-title">{{month.month}}</h2>
                                    </div>
                                    
                                </div>
                            </div>
                            
                            <p class="content__item-description" v-html="month.text"></p>
                        </div>
                        <!-- <div class="content__item content__item--expand" style="--aspect-ratio: 800/462;">
                            <div class="content__item-imgwrap">
                                <div class="content__item-img" style="background-image: url(../../assets/images/governance/rule1.png);"></div>
                            </div>
                            <h2 class="content__item-title">Nj</h2>
                            <p class="content__item-description">All you have to learn here is how to have fun. No pressure. Just relax and watch it happen.</p>
                        </div>
                        <div class="content__item content__item--expand" style="--aspect-ratio: 700/447;">
                            <div class="content__item-imgwrap">
                                <div class="content__item-img" style="background-image: url(../assets/images/governance/rule1.png);"></div>
                            </div>
                            <h2 class="content__item-title">Al</h2>
                            <p class="content__item-description">Just let your mind wander and enjoy. This should make you happy. There are no mistakes. You can fix anything that happens.</p>
                        </div>
                        <div class="content__item content__item--expand" style="--aspect-ratio: 500/750;">
                            <div class="content__item-imgwrap">
                                <div class="content__item-img" style="background-image: url(../assets/images/governance/rule1.png);"></div>
                            </div>
                            <h2 class="content__item-title">Ut</h2>
                            <p class="content__item-description">We don't have to be committed. We are just playing here. Even the worst thing we can do here is good.</p>
                        </div>
                        <div class="content__item content__item--expand" style="--aspect-ratio: 700/525;">
                            <div class="content__item-imgwrap">
                                <div class="content__item-img" style="background-image: url(../assets/images/governance/rule1.png);"></div>
                            </div>
                            <h2 class="content__item-title">Wa</h2>
                            <p class="content__item-description">Decide where your cloud lives. Maybe he lives right in here. Little short strokes.</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import "@/assets/js/yearinreview.js";
import "@/assets/css/base.css";
import data from "@/components/data/yearInReview.json";
    export default {
        data(){
            return{
                data:data
            }
        },
        created(){
            if(this.$i18n.locale=="en"){
                this.data = this.data.en.contents;
            }
            else{
                this.data = this.data.ar.contents;
                
            }
        },
    }
</script>

<style lang="scss" scoped>
.content--padded{
    padding-top: rem(0px);
}

</style>